<script>
	export default {
		props: {
			url: {
				type: String,
				required: true
			},
			post_sucursal: {
				default: 0
			},
			post_vendedor: {
				default: 0
			},
			sm: {
				type: String,
				required: false,
				default: "CIR"
			}
		},
		data() {
			return {
				sucursal: 0,
				vendedor: 0,
				sucursales: []
			};
		},
		created() {
			this.sucursal = Number(this.post_sucursal);
			this.vendedor = Number(this.post_vendedor);
			axios
				.get(this.url + "/mkte_sucursales/sucursales.json.php", {
					params: {
						modulo: this.sm
					}
				})
				.then(response => {
					this.sucursales = response.data.sucursales;
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {});
		},
		watch: {
			sucursal(value) {
				if (value === 0) {
					this.vendedor = 0;
				}
			}
		},
		computed: {
			listo() {
				return this.sucursales.length > 0;
			},
			cargando() {
				return !(this.sucursales.length > 0);
			},
			vendedores() {
				let vendedores = [];
				if (!this.cargando && this.sucursal > 0) {
					let sucursal = _.find(this.sucursales, ["id", this.sucursal]);
					if ("vendedores" in sucursal) {
						vendedores = sucursal.vendedores;
					}
				}
				return vendedores;
			}
		}
	};
</script>

<template>
	<div class="panel panel-default" id="sucursales">
		<div class="panel-heading" v-html="'Selecci&oacute;n de Vendedor &amp; Sucursal'"></div>

		<div class="list-group">
			<!-- Sucursal -->
			<div class="list-group-item">
				<div class="form-group" v-bind:class="{'has-success': sucursal > 0 && listo}">
					<label for="sucursal">Sucursal</label>
					<div class="input-group input-group-sm">
						<div class="input-group-addon">
							<i class="fa fa-refresh fa-spin fa-fw" v-if="cargando"></i>
							<i class="fa fa-map-marker" v-else></i>
						</div>
						<select
							class="form-control"
							name="sucursal"
							id="sucursal"
							v-model="sucursal"
							v-bind:disabled="cargando"
							required
						>
							<option v-bind:value="0">Seleccionar</option>
							<option
								v-for="(sucursal,key) in sucursales"
								:key="key"
								:value="sucursal.id"
								v-text="sucursal.nombre"
							></option>
						</select>
					</div>
				</div>
			</div>
			<!-- Vendedor -->
			<div class="list-group-item">
				<div class="form-group" v-bind:class="{'has-success': vendedor > 0 && listo}">
					<label for="vendedor">Vendedor</label>
					<div class="input-group input-group-sm">
						<div class="input-group-addon">
							<i class="fa fa-user"></i>
						</div>
						<select
							class="form-control"
							name="vendedor"
							id="vendedor"
							v-model="vendedor"
							v-bind:disabled="!(vendedores.length > 0)"
							required
						>
							<option v-bind:value="0">Seleccionar</option>
							<option
								v-for="(vendedor, key) in vendedores"
								:key="key"
								:value="vendedor.id"
								v-text="vendedor.nombre_completo"
							></option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
    

</style>